export const IconGradientStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.19914 0.557341C7.47424 -0.186106 8.52576 -0.186106 8.80086 0.557341L10.4584 5.03682C10.5449 5.27056 10.7292
       5.45485 10.9629 5.54134L15.4424 7.1989C16.1859 7.474 16.1859 8.52551 15.4424 8.80061L10.9629 10.4582C10.7292 10.5447
        10.5449 10.729 10.4584 10.9627L8.80086 15.4422C8.52576 16.1856 7.47424 16.1856 7.19914 15.4422L5.54158
         10.9627C5.45509 10.7289 5.27081 10.5447 5.03707 10.4582L0.557585 8.80061C-0.185862 8.52551 -0.185862
          7.474 0.557585 7.1989L5.03707 5.54134C5.27081 5.45485 5.45509 5.27056 5.54158 5.03682L7.19914 0.557341Z"
      fill="url(#paint0_linear_1427_16181)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1427_16181"
        x1="15.6471"
        y1="12.7998"
        x2="-0.358137"
        y2="10.567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006BFF" />
        <stop offset="0.9999" stopColor="#C600EC" />
      </linearGradient>
    </defs>
  </svg>
)
